import { connect } from 'react-redux';
import { makeStyles, tokens } from '@fluentui/react-components';
import { AppState } from '../../../redux/reducers';
import { ErrorType } from '../../../models/HttpError';
import { CreateSector } from '../../../models/Entities/Turnero';
import * as SectoresStore from '../../../redux/middleware/Turnero/Turnero.Sectores.Middleware';

export interface OwnProps {
  branchId: number;
  onCreated?: () => void;
  onCancel?: () => void;
}

interface StateProps {
  isSaving: boolean;
  isSaved: boolean | undefined;
  failOnSaving: boolean;
  error: ErrorType | undefined;
}

interface DispatchProps {
  CreateSector: typeof SectoresStore.actionCreators.CreateSector;
}

export type Props = OwnProps & StateProps & DispatchProps;

export const mapStateToProps = (state: AppState, _ownProps: OwnProps): StateProps => ({
  isSaving: state.Turnero?.Sectores?.isAddingNewOne || false,
  isSaved: state.Turnero?.Sectores?.successAddingNewOne,
  failOnSaving: state.Turnero?.Sectores?.failOnAddingNewOne || false,
  error: state.Turnero?.Sectores?.error
});

export const mapDispatchToProps = {
  CreateSector: SectoresStore.actionCreators.CreateSector
};

export const useStyles = makeStyles({
  inlineForm: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: tokens.spacingHorizontalS,
    padding: tokens.spacingHorizontalS,
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusMedium,
  },
  fields: {
    display: 'flex',
    gap: tokens.spacingHorizontalS,
    flexWrap: 'wrap',
  },
  actions: {
    display: 'flex',
    gap: tokens.spacingHorizontalXXS,
    alignItems: 'center',
  },
});

export const connector = connect(mapStateToProps, mapDispatchToProps);
